//Main function to update cart qty, remove item, add item, change item qty***********
async function updateCartQuantity(key, quantity) {
  try {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: { [key]: quantity } }),
    });
    if (!response.ok) throw new Error("Cart update failed");
    const cart = await response.json();
    return cart;
  } catch (error) {
    console.error("Cart update error:", error);
  }
}


// Qty increse, decrease function ***********
async function handleQuantityChange(input) {
	try {
      
		$(".cart-item-quantity-box button").attr("disabled", true);
		const cartItemKey = input.currentTarget.id;
		const newQuantity = input.currentTarget.valueAsNumber;

		const cart = await updateCartQuantity(cartItemKey, newQuantity);
      
        updateUI(cart);

		if (newQuantity === 0) {
			removeCartItemElement(cartItemKey);
            checkExistingCardAddon();
            datepickerModule.checkedProductSpecialTags();
		}

		$(".cart-item-quantity-box button").attr("disabled", false);
      
	} catch (error) {
		console.log(error);
	}
}

// Events Handling************
function bindEvents() {
   $(".cart-item-quantity-box input.quantity").on("change", handleQuantityChange);
  
    $("button#delete-item-button").on("click", function (e) {
    	e.preventDefault();
    	$(`.cart-item-quantity-box input[data-key="${e.currentTarget.dataset.key}"]`)
    		.val(0)
    		.trigger("change");
   });
}


// Update cart total price, cart qty in the header***********
function updateUI(cart) {

   ['p.cart-total-price span.money', '.mobile-sticky-checkout button .money']
    .forEach(selector => {
      const el = document.querySelector(selector);
      if (el){ 
        el.textContent = Shopify.formatMoney(cart.total_price, $('body').data('money-format'))
      }
    });

  const cartIconQuantityElement = document.querySelectorAll("span.cart_count");
	cartIconQuantityElement.forEach((el) => {
		el.innerHTML = cart.item_count;
	});

}

// Remove product from cart api *************
async function removeCartItemElement(key) {
	const desktopCartItemElement = document.querySelector(`tr[data-key="${key}"]`);
	const mobileCartItemElement = document.querySelector(`.cart-item-container[data-key='${key}']`);
  
	desktopCartItemElement?.remove();
	mobileCartItemElement?.remove();

    const getAllNoSaturdayProduct = document.querySelectorAll(".no-saturdays");
	if (getAllNoSaturdayProduct.length === 0) {
		PRODUCTCONFIG.noSaturday = false;
	}
  
    const getAllNoSundayProduct = document.querySelectorAll(".no-sundays");
	if (getAllNoSundayProduct.length === 0) {
		PRODUCTCONFIG.noSunday = false;
	}

    const getAllMarketplaceItem = document.querySelectorAll(".marketplace_item");
	if (getAllMarketplaceItem.length === 0) {
		PRODUCTCONFIG.hasMarketPlaceProduct = false;
		$(".marketplace").removeClass("marketplace_true");
		$(".marketplace-remark").hide();
	}
  
    const getAllExpressProduct = document.querySelectorAll(".expressproduct");
	if (getAllExpressProduct.length === 0) {
		PRODUCTCONFIG.hasProductExpress = false;
	}

	const cartItemsMobile = document.querySelectorAll(".cart-item-container");
	const cartItemsDesktop = document.querySelectorAll("tbody tr");

	if (cartItemsDesktop.length === 0 || cartItemsMobile.length === 0) {
		location.reload();
	}
}

// Get Vissible elements from html ************
function getUniqueElements(elements) {
  return Array.from(elements).filter(el => el.offsetParent !== null);
}


const cardMessageTextarea = document.querySelector(".card-message-textarea");

cardMessageTextarea.addEventListener("input", function (e) {
    if (e.target.value.length > 1) {
        $(".card-message-textarea").removeClass("field-error");
    }
});


// Validation akhan theke suru ***************
let greetingCardConfirmed = false;
let emptyMessageCardChecked = false;

function checkEmptyMessageCard() {
  if (!cardMessageTextarea.value) {
    RakibAlert.confirm({
      title: 'Confirm Action',
      message: `Do you want to proceed with an <b>Empty message card?</b>`,
      type: 'error',
      buttons: [
        {
          text: 'Cancel',
          type: 'danger',
          onClick: function () {
            $(".card-message-textarea").addClass("field-error");
            this.close();
            const element = document.querySelector(".card-message-textarea");
            $(window).scrollTop(element.offsetTop - 300);
            emptyMessageCardChecked = false;
            return;
          }
        },
        {
          text: 'Continue',
          type: 'secondary',
          onClick: function () {
            emptyMessageCardChecked = true; 
            this.close();
            $(".card-message-textarea").removeClass("field-error");
            $(".checkout_original").trigger("click");
          }
        }
      ]
    });
  } else {
     $(".checkout_original").trigger("click");
  }
}

function cartProductValidation(){
  //Product class diye check kore dekte hobe****
  const allCartItems = getUniqueElements(document.querySelectorAll(".cart-single-item"));
  const cartAddonItems = document.querySelectorAll(".cart-item-container.is-addon");
  const greetingCards = document.querySelectorAll(".cart-item-container.greeting-cards");
  const tierFailedItem = getUniqueElements(document.querySelectorAll('.tier-error'));
  

   if(tierFailedItem.length > 0 ){
    RakibAlert.error('Please remove <b>not available product</b> to proceed checkout.', 'Error');    
    scrolltoTop();
    return;
  }


  if(allCartItems.length === cartAddonItems.length ){
    RakibAlert.error('Please select at least one <b>non-addon product</b> to proceed to checkout.', 'Error');    
    scrolltoTop();
    return;
  }

  if (greetingCards.length === 0 && !greetingCardConfirmed) {
      const card = document.querySelector("#card-addons-slider");
      RakibAlert.confirm({
        title: 'Confirm Action',
        message: `You have not selected a <b>message card.</b> Do you want to proceed without a <b>card?</b>`,
        type: 'error',
        buttons: [
          {
            text: 'Cancel',
            type: 'danger',
            onClick: function () {
              $(card).addClass("field-error");
              this.close();
              $(window).scrollTop(card.offsetTop - 200);
              return;
            }
          },
          {
            text: 'Continue',
            type: 'secondary',
            onClick: function () {
              greetingCardConfirmed = true;
              this.close();
              $(card).removeClass("field-error");
              $(".checkout_original").trigger("click");
            }
          }
        ]
      });
      return;
    } else {
      checkEmptyMessageCard();
    }
}

function cartFormValidations (){
  const deliveryPostcodeInput = document.querySelector("#postcode-input-js");
  const deliveryDateInput = document.querySelector("#order_date");
  const deliveryTimeslotInput = document.querySelector("#order_time");
  const inputList = ["Delivery Postcode", "Delivery Date", "Delivery Time Slot"];
  const inputValues = [
		deliveryPostcodeInput.value,
		deliveryDateInput.value,
		deliveryTimeslotInput.value,
	];
 
  if (!deliveryPostcodeInput.value || !deliveryDateInput.value || !deliveryTimeslotInput.value) {
		const emptyValues = [];
		inputValues.forEach((value, index) => {
			if (!value) {
				emptyValues.push(inputList[index]);
			}
		});

       RakibAlert.error( `Please complete the following <b>${emptyValues.toString()}</b> to proceed.`, 'Error');

      if (!deliveryPostcodeInput.value) {
		 	$("#postcode-input-js").addClass("field-error");
	   }
      if (!deliveryDateInput.value) {
          $("#datepicker-group-js").addClass("field-error");
      }
      if (!deliveryTimeslotInput.value) {
          $("#timeslot-container-js").addClass("field-error");
      }
           
      scrolltoTop();
      return;
  }

  cartProductValidation();
  
}

function cartMarketProductValidation(){
  cartProductValidation();
}

$("#checkout_clone, .mobile-sticky-checkout button").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    if(PRODUCTCONFIG.hasMarketPlaceProduct){
      cartMarketProductValidation();
    } else {
        if (PRODUCTCONFIG.checkoutValidation){
           cartFormValidations();
        } else {
          RakibAlert.error('Please complete all required delivery information to proceed.', 'Error');
          scrolltoTop();
        }
    }
});

// Validation akhan theke ses ***************
document.addEventListener("DOMContentLoaded", () => {
  bindEvents();
  checkExistingCardAddon();
  
});

function scrolltoTop(){
   if (window.innerWidth >= 1024) {
    window.scrollTo(0, 0);
  } else {
      const form = document.querySelector("form#cart_form");
      $(window).scrollTop(form.offsetTop - 175);
  }
}


// Addons Functionality akhan theke suru***************************  
const selectedCartAddons = new Set();
let selectedCard = null;
const cardAddons = document.querySelectorAll(".card-addons-item");
const cartAddons = document.querySelectorAll(".cart-addons-product-js");
function addonsInCart(){
  cardAddons.forEach(card => {
   card.addEventListener("click", function(event) {
      handleAddonClicked.call(this, event, false);
      document.getElementById("card-addons-slider").classList.remove("field-error");
    });
  });
  
  cartAddons.forEach(addon => {
   addon.addEventListener("click", function(event) {
      handleAddonClicked.call(this, event, true);
    });
  });
  
  async function handleAddonClicked(event, multiSelection) {
    try {
      
      const variantId = this.dataset.vid;
      applyBlurEffect(this);
  
      const isSelected = this.classList.contains('card-addons-selected');
      if (isSelected) {
        const cart = await updateCartQuantity(variantId, 0);
        updateCardAddonDisplay(cart);
        updateUI(cart);
        this.classList.remove('card-addons-selected');
        if (multiSelection) selectedCartAddons.delete(variantId);
        else selectedCard = null;
      } else {
        if (!multiSelection && selectedCard) {
          selectedCard.classList.remove('card-addons-selected');
          await updateCartQuantity(selectedCard.dataset.vid, 0);
        }
        const cart = await updateCartQuantity(variantId, 1);
        updateCardAddonDisplay(cart);
        updateUI(cart);
        this.classList.add('card-addons-selected');
        if (multiSelection) selectedCartAddons.add(variantId);
        else selectedCard = this;
      }
  
      removeBlurEffect(this);
    } catch (error) {
      removeBlurEffect(this);
    }
  }
  
  function applyBlurEffect(clickedCard) {
    const slideList = clickedCard.closest(".splide__list");
    const slides = slideList.querySelectorAll(".splide__slide");
    slides.forEach(card => {
      if (card !== clickedCard) {
        card.classList.add('card-blur');
      }
    });
    clickedCard.classList.add('addons-loading');
  }
  
  function removeBlurEffect(clickedCard) {
    const slideList = clickedCard.closest(".splide__list");
    const slides = slideList.querySelectorAll(".splide__slide");
    slides.forEach(card => {
      card.classList.remove('card-blur', 'addons-loading');
    });
  }
}
addonsInCart();

async function updateCardAddonDisplay(cart) {
  const sectionResponse = await fetch(`?section_id=cart-template-v3`);
  if (!sectionResponse.ok) throw new Error('Failed to fetch cart template');
  const sectionHTML = await sectionResponse.text();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = sectionHTML;
  const newCartItemsContainer = tempDiv.querySelector(".cart-items-container");
  const currentCartItemsContainer = document.querySelector(".cart-items-container");
  if (newCartItemsContainer && currentCartItemsContainer) {
    currentCartItemsContainer.innerHTML = newCartItemsContainer.innerHTML;
  } else {
    console.warn('Cart items container not found');
  }

  bindEvents();
  
}


async function checkExistingCardAddon() {

    const response = await fetch("/cart.js");
    const cart = await response.json();
    let foundInCart = false;
    let selectedIndex = 0;

    //Greetings card addon
    cardAddons.forEach((card, index) => {
      const variantId = card.dataset.vid;
      const cartItem = cart.items.find(item => item.variant_id.toString() === variantId);
      if (cartItem && cartItem.quantity > 0) {
        card.classList.add('card-addons-selected');
        selectedCard = card;
        foundInCart = true;
        selectedIndex = index;
      } else {
        card.classList.remove('card-addons-selected');
      }
    });

    //Cart Addons
    cartAddons.forEach((addon, index) => {
      const variantId = addon.dataset.vid;
      const cartItem = cart.items.find(item => item.variant_id.toString() === variantId);
      if (cartItem && cartItem.quantity > 0) {
        addon.classList.add('card-addons-selected');
        selectedCard = addon;
      } else {
        addon.classList.remove('card-addons-selected');
      }
    });

    if (window.splide) {
      window.splide.go(foundInCart ? selectedIndex : 0);
    }
    if (!foundInCart) selectedCard = null;

}


document.addEventListener("DOMContentLoaded", () => {
  bindEvents();
  checkExistingCardAddon();
});

